const ERROR_MESSAGE = {
    required: 'This is required',
    email: 'Invalid Email Address',
    url: 'Invalid URL',
    group: 'Please select atleast one option',
    link: 'Invalid URL',
    number: 'Invalid number',
    pattern: 'Please match the requested format',
    length: {
        short(val) { return `Text must be ${val} or more characters` },
        long(val) { return `Text must be ${val} or less characters` }
    },
    range: {
        under(val) { return `Value must be ${val} or greater` },
        over(val) { return `Value must be ${val} or lesser` }
    }
}


let checkboxChecked = 0;
let checkboxSelected = [];


// Validate field
// Return message
export function hasError (field) {
    // Do not validate the ff fields:
    // Button; file and reset inputs; and disabled fields
    if (field.disabled || field.type == 'file' || field.type == 'reset' || field.type == 'submit' || field.type == 'button' || field.name == '_token') { return; }

    if (field.type == 'radio' || field.type == 'checkbox') {
        if (field.checked) {
            checkboxSelected.push(field);
        }

        if (checkboxSelected.length > 0) { return; }

        return ERROR_MESSAGE.group;
    }

    // Get validity
    const validity = field.validity;

    console.log(field.type, validity);

    // If valid return null
    if (validity.valid) { return; }

    if (validity.badInput) {
        if (field.type == 'number') {
            return ERROR_MESSAGE.number;
        }
    }

    // If field is required and it's empty
    if (validity.valueMissing) {
        return ERROR_MESSAGE.required;
    }

    // If text is too short
    if (validity.tooShort) {
        return ERROR_MESSAGE.length.short(field.minLength);
    }

    // If text is too long
    if (validity.tooLong) {
    }

    // If number is less than the min value
    if (validity.rangeUnderflow) {
        return ERROR_MESSAGE.range.under(field.min);
    }

    // If number is greater than max value
    if (validity.rangeOverflow) {
        return ERROR_MESSAGE.range.over(field.max);
    }

    // If
    if (validity.badInput) {
        if (field.type == 'number') {
            return ERROR_MESSAGE.number;
        }
    }

    // If field type is mismatch
    if (validity.typeMismatch) {
        // If email is not match
        if (field.type == 'email') {
            return ERROR_MESSAGE.email;
        }

        // If url is not match
        if (field.type == 'url') {
            return ERROR_MESSAGE.url;
        }
    }

    if (validity.patternMismatch) {
        const msg = field.hasAttribute('data-pattern-message') ? field.getAttribute('data-pattern-message') : ERROR_MESSAGE.pattern;
        return msg;
    };

    return;
}


// Show error message
export function showError (form, field, error) {

    // if ((field.type == 'radio' || field.type == 'checkbox') && field.name) {
    if ((field.type == 'radio' || field.type == 'checkbox') && field.name) {
        const group = form[field.name];
        const chckbx = [];

        if (group.length > 0) {
            for (let i = 0; i < group.length; i++) {
                if (group[i].form !== field.form) { continue; }

                if (group[i].checked) { chckbx.push(group[i]); }

                group[i].classList.add('has-error');
            }

            if (chckbx.length > 0) {
                removeError(form, field);
                return;
            }

            field = group[group.length - 1];

            error = ERROR_MESSAGE.group;
        }
    }


    // Get field attribute id or name
    const _id = field.id || field.name;

    if (!_id) { return; }

    let _message = document.querySelector(`#error-for-${_id}`);

    // Check if error message already exist
    if (!_message) {
        _message = document.createElement('span');
        _message.className = 'o-error js-error';
        _message.id = `error-for-${_id}`;

        // Add error class to the field
        field.classList.add('has-error');

        let label;

        if (field.type == 'radio' || field.type == 'checkbox') {
            label = field.parentNode;

            if (label) {
                label.parentNode.insertBefore(_message, label.nextSibling)
            }
        }

        if (!label) {
            field.parentNode.insertBefore(_message, field.nextSibling);
        }

        _message.classList.add('is-active');

        setTimeout(() => {
            _message.classList.add('is-visible');
        }, 100);
    }

    _message.innerHTML = error;

}


// Hide Error Message;
export function removeError (form, field) {

    // remove error class to the field
    field.classList.remove('has-error');

    if ((field.type == 'radio' || field.type == 'checkbox') && field.name) {
        const group = form[field.name];

        if (group.length > 0) {
            for (let i = 0; i < group.length; i++) {
                if (group[i].form !== field.form) { continue; }

                group[i].classList.remove('has-error');
            }

            field = group[group.length - 1];
        }
    }


    // Get field attribute id or name
    const _id = field.id || field.name;

    if (!_id) { return; }

    let _message = document.querySelector(`#error-for-${_id}`);

    if (!_message) { return; }

    _message.classList.remove('is-visible');

    setTimeout(() => {
        _message.classList.remove('is-active');
        _message.remove();
    }, 300);
}



export function handleSubmit(e) {
    // Get all fields from form element
    const fields = e.elements;
    let error,
        hasErrors;

    for (let i = 0; i < fields.length; i++) {
        error = hasError(fields[i]);

        if (error) {
            showError(fields[i], error);

            if (!hasErrors) {
                hasErrors = fields[i];
            }
        }

        // If there's an erro prevent form from submitting
        // Focus on the error field
        if (hasErrors) {
            e.preventDefault();
            hasErrors.focus();
        }
    }
}


export function handleEvents(form) {
    let ev,
        error,
        chkbx

    for (let i = 0; i < form.length; i++) {

        // if (form[i].type == 'checkbox') { return; }

        // ev = form[i].type == 'checkbox' || form[i].type == 'radio' ? 'change' : 'blur';
        ev = form[i].type == 'radio' || form[i].type == 'checkbox' ? 'change' : 'blur';

        form[i].addEventListener(ev, e => {
            error = hasError(e.target);

            // if has error
            if (error) {
                showError(form, e.target, error);
                return;
            }

            // remove error
            removeError(form, e.target, error);
        });
    }
}


export function focus(field) {

    field.focus();

    if (field.type == 'text' || field.type == 'search' || field.type == 'url' || field.type == 'email' || field.type == 'textarea') {
        field.setSelectionRange(field.value.length, field.value.length);
    }
}
